<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <InputLabel :label="label" :tooltip="tooltip" :is-error="isError" :warning="warning">
    <div
      :class="{
        'cursor-not-allowed opacity-50': disabled,
      }"
    >
      <Multiselect
        :model-value="modelValue"
        mode="single"
        :placeholder="placeholder"
        :options="options"
        :disabled="disabled"
        :searchable="true"
        :track-by="trackBy"
        :classes="{
          container: 'relative box-border flex w-full cursor-pointer rounded-sm',
          containerOpen: 'ring-2 !ring-ring !ring-offset-2 !ring-shadow-transparent',
          wrapper: input({ class: 'relative flex justify-start pr-6', size: 'sm' }),
          caret:
            'bg-multiselect-caret bg-center bg-no-repeat w-2 h-4 py-px box-content relative z-10 opacity-40 flex-shrink-0 flex-grow-0 transition-transform transform pointer-events-none opacity-20',
          caretOpen: 'rotate-180 pointer-events-auto',
          search: 'w-full border-none outline-none bg-transparent',
          clear: 'hidden',
          option:
            'flex items-center justify-start box-border text-left cursor-pointer text-sm leading-snug py-2 px-2',
          optionSelected: 'text-white bg-primary',
          optionPointed: 'text-gray-800 bg-gray-100',
          clearIcon:
            'bg-multiselect-remove bg-center bg-no-repeat w-2 h-4 py-px box-content inline-block',
          singleLabel:
            'flex items-center h-full max-w-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug py-2 px-3 pr-6 box-border',
          spacer: '',
        }"
        @update:model-value="emit('update:modelValue', $event)"
      >
        <template #caret="{ handleCaretClick }">
          <div
            class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2"
            @click="handleCaretClick"
          >
            <ChevronDownIcon class="h-4 w-4 text-primary" />
          </div>
        </template>

        <template #option="{ option }">
          <p>{{ option.label }}</p>
        </template>
      </Multiselect>
    </div>
    <InputHint :hint="hint" :is-error="isError" />
  </InputLabel>
</template>

<script setup lang="ts">
import { input } from '@carvia/theme/lib/cva/input.ts';
import { ChevronDownIcon } from '@heroicons/vue/24/solid';
import InputLabel from './InputLabel.vue';
import InputHint from './InputHint.vue';

export interface SearchableSelectOptionData {
  label: string;
  value: string | number;
}

const props = defineProps<{
  modelValue?: string | number;
  label?: string;
  placeholder?: string;
  hint?: string;
  options: SearchableSelectOptionData[];
  tooltip?: string;
  warning?: string;
  isError?: boolean;
  disabled?: boolean;
  trackBy?: string[];
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number | undefined): void;
}>();
</script>
